import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const FREE_TRIAL_I18N_NAMESPACE = '@mc/free-trial'

export const i18nInstance = registerI18nResources({
  namespace: FREE_TRIAL_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
